import { css } from "styled-components"
import shadowHorizontal from "assets/shadow-horizontal.png"

const SHADOW_HEIGHT = "5px"
const shadowCSS = css`
  position: relative;

  &:after {
    display: flex;
    width: 100%;
    height: ${SHADOW_HEIGHT};

    position: absolute;
    bottom: -${SHADOW_HEIGHT}; /* So that the shadow starts at the bottom of the component */
    left: 0;

    content: "";
    background: url(${shadowHorizontal}) repeat-x;
  }
`

export default shadowCSS
